<script lang="ts">
  import Spinner from './Spinner.svelte'
</script>

<div class="empty-section tc">
  <Spinner/>
</div>